import styled from "styled-components";

import { filterFactory } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

export type QuickFilterId = "emerging" | "declining" | "new";

interface IQuickFilterState {
    quickFilter?: QuickFilterId;
}

interface IQuickFilterItem {
    id: QuickFilterId;
    title: string;
}

interface IKeywordsBreakdownQuickFiltersProps {
    selected: QuickFilterId | undefined;
    onChange: (next: QuickFilterId | undefined) => void;
    counts: Record<QuickFilterId, number>;
    isLoading: boolean;
}

const Filter = filterFactory.createTypedFilters<IQuickFilterState>();

const QuickFiltersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    padding: 16px;
    background-color: ${colorsPalettes.carbon[0]};
`;

const buildItems = (): IQuickFilterItem[] => [
    {
        id: "emerging",
        title: translate("demand.analysis.search.trends.keywords.quick.filter.emerging.title"),
    },
    {
        id: "declining",
        title: translate("demand.analysis.search.trends.keywords.quick.filter.declining.title"),
    },
    {
        id: "new",
        title: translate("demand.analysis.search.trends.keywords.quick.filter.new.title"),
    },
];

export const KeywordsBreakdownQuickFilters = ({
    selected,
    onChange,
    counts,
    isLoading,
}: IKeywordsBreakdownQuickFiltersProps) => {
    const items = buildItems();
    const fieldLabel = translate("demand.analysis.search.trends.keywords.quick.filter.field.label");

    const handleChange = (nextState: IQuickFilterState) => {
        const incoming = nextState.quickFilter;
        const next = incoming === selected ? undefined : incoming;

        if (next) {
            allTrackers.dispatchTrackEvent("Button", "click", `Select Keywords Quick Filter/${next}`);
        } else if (selected) {
            allTrackers.dispatchTrackEvent("Button", "click", `Deselect Keywords Quick Filter/${selected}`);
        }

        onChange(next);
    };

    return (
        <Filter.Provider
            state={{ quickFilter: selected }}
            onChange={handleChange}
        >
            <QuickFiltersGrid data-automation="keywords-breakdown-quick-filters">
                {items.map((item) => (
                    <div
                        key={item.id}
                        data-automation={`keywords-breakdown-quick-filter-${item.id}`}
                    >
                        <Filter.QuickFilter
                            title={item.title}
                            isLoading={isLoading}
                            fieldText={counts[item.id].toLocaleString()}
                            fieldLabel={fieldLabel}
                            value={{ quickFilter: item.id }}
                        />
                    </div>
                ))}
            </QuickFiltersGrid>
        </Filter.Provider>
    );
};
